// src/hooks/useOwnerAnalytics.ts — async loader for /owner/analytics/{kind}.
import { ownerService } from '@/core/services/ownerService';
import { useOwnerList } from './useOwnerList';
import type { AnalyticsPayload } from '@/core/models';

export function useOwnerAnalytics(kind: string, rangeDays = 7) {
  return useOwnerList<AnalyticsPayload>(
    () => ownerService.getAnalytics(kind, rangeDays),
    [kind, rangeDays],
  );
}
